import classes from "./ActivityEditor.module.css";
import React, {Fragment, useEffect, useLayoutEffect, useState} from "react";
import {UserApiCalls} from "../../apis/UserApiCalls";
import Skeleton, {SkeletonTheme} from "react-loading-skeleton";
import {YuJaTextBox} from "../../components/standardization/YuJaTextBox";
import YuJaButton from "../../components/standardization/YuJaButton";
import {ReactComponent as CLOSE} from "../../images/Close.svg"
import { ReactComponent as SearchIcon } from "../../images/search_bar_icon.svg";
import {ReactComponent as NoResultImage} from "../../images/no-result-found.svg";
import {
    DEFAULT_ROWS_PER_PAGE,
    QUESTION_BANK_TITLE_HEADER, QUESTION_TYPES, TOTAL_POINTS_TEXT, TOTAL_QUESTIONS_TEXT, TYPE, USER_SETTINGS
} from "../../utils/constants";
import {
    getQuestionWeightage,
    removePrefixNew
} from "../../utils/helpers";
import {useGlobalFilter, usePagination, useTable} from "react-table";
import TableSortHeaderNew from "../../components/TableSortHeaderNew";
import {Table} from "react-bootstrap";
import { Radio } from '@base-ui/react/radio';
import { RadioGroup } from '@base-ui/react/radio-group';
import radioClasses from "../../components/standardization/YuJaRadioBox.module.css";
import NormalPagination from "../../components/pagination/NormalPagination";
import QuestionAccordion from "./QuestionAccordion";
import {convertMHOptionMap} from "../../utils/questionUtils";

export default function ImportQuestionsQuestionBank({
                                                        selectedWorkflow,
                                                        draftActivity,
                                                        userSettings,
                                                        importedQuestions,
                                                        setImportedQuestions,
                                                        setIsSelectedImportItem
}) {
    let activeStep = selectedWorkflow.steps.find(s => !!s.active);

    const { listQuestionProfiles } = UserApiCalls();
    const [isLoading, setIsLoading] = useState(true);
    const [questionBanks, setQuestionBanks] = useState([]);
    const [selectedQuestionBank, setSelectedQuestionBank] = useState("");
    const [keyword, setKeyword] = useState("");
    const [sortedBy, setSortedBy] = useState("");

    const [fakePoll, setFakePoll] = useState(() => {
        let copy = JSON.parse(JSON.stringify(draftActivity));
        const {questions, ...rest} = copy;
        return {poll: rest, questions: []};
    });

    useEffect(() => {
        setIsLoading(true);
        listQuestionProfiles().then(res => {
            const sortedArray = Object.values(res)
                .map(i => ({
                    id: removePrefixNew(i.pk),
                    totalQuestions: i.questions ? i.questions.length : 0,
                    totalPoints: i.questions ? i.questions.reduce((accumulator, obj) => {
                        return accumulator + getQuestionWeightage(obj);
                    }, 0) : 0,
                    ...i
                }))
                .sort((a, b) => new Date(Date.parse(b.creationTime)) - new Date(Date.parse(a.creationTime)));
            setQuestionBanks(sortedArray);
        }).finally(() => setIsLoading(false));
    }, []);

    useEffect(() => {
        if (!!selectedQuestionBank) {
            setIsSelectedImportItem(true);
            let copy = JSON.parse(JSON.stringify(draftActivity));
            const {questions, ...rest} = copy;
            let qb = questionBanks.find(qb => qb.id === selectedQuestionBank);
            let qbCopy = JSON.parse(JSON.stringify(qb));

            copy.questions = qbCopy.questions;
            for (const q of copy.questions) {
                if (q.questionType === QUESTION_TYPES.MH.name && (!q.hasOwnProperty("optionsMap") || !q.optionsMap)) {
                    q.optionsMap = convertMHOptionMap(q.correctAnswers);
                }
            }
            setFakePoll({poll: rest, questions: qbCopy.questions});
            setImportedQuestions(qbCopy.questions);
        } else {
            setIsSelectedImportItem(false);
            setImportedQuestions([]);
        }
    }, [selectedQuestionBank]);

    // useLayoutEffect(() => {
    //     if (document.activeElement === null || document.activeElement.tagName === "BODY") {
    //         let closeBtn = document.getElementById("import_question_close_icon");
    //         if (closeBtn) {
    //             closeBtn.focus();
    //         }
    //     }
    // }, []);


    // 1. Memoize your columns
    const columns = React.useMemo(() => [
        { Header: QUESTION_BANK_TITLE_HEADER, accessor: "title", width: 300 },
        { Header: TOTAL_QUESTIONS_TEXT, accessor: "totalQuestions", width: 150, maxWidth: 250 }, // Fixed accessor
        { Header: TOTAL_POINTS_TEXT, accessor: "totalPoints", width: 150, maxWidth: 250 },     // Fixed accessor
    ], []);

// 2. Memoize your filter function
    const filterCustomize = React.useMemo(() => (rows, _, filterValue) => {

        if (!filterValue || Object.entries(filterValue).length === 0) {
            return rows;
        }

        const filteredKeyword = filterValue.keyword ? filterValue.keyword.toLowerCase().trim() : "";
        return rows.filter(r => {
            const title = r.values.title;
            return title && title.toLowerCase().includes(filteredKeyword);
        });
    }, []);

    useEffect(() => {
        setGlobalFilter({keyword});
    }, [questionBanks, keyword]);

    const {
        getTableProps,
        getTableBodyProps,
        headerGroups,
        prepareRow,
        page,
        canPreviousPage,
        canNextPage,
        pageOptions,
        pageCount,
        gotoPage,
        nextPage,
        previousPage,
        state: { pageIndex},
        setGlobalFilter,
    } = useTable({
        columns,
        data: questionBanks,
        initialState: { pageIndex: 0, pageSize: 6},
        autoResetPage: true,
        globalFilter: filterCustomize,
    }, useGlobalFilter, usePagination);


    if (isLoading) {
        return (
            <div className={classes.column} style={{width: "100%"}}>
               <div style={{maxWidth: "min(100%, 400px)"}}>
                    <Skeleton width={"100%"} height={23} borderRadius={4} />
               </div>

                <div style={{maxWidth: "min(100%, 500px)"}}>
                    <Skeleton width={"100%"} height={40} borderRadius={4} style={{marginTop: 25, marginBottom: 15}}/>
                </div>

                <div className={classes.skeletonTableContainer}>

                    <SkeletonTheme color="rgba(237, 237, 237, 1)" highlightColor="lightgrey">
                        <div className={classes.skeletonHeaderContainer}>
                            <Skeleton borderRadius={10} height={20} inline={true} width="10vw"
                                      containerClassName={classes.skeletonBodyCellWrapper}/>
                            <Skeleton borderRadius={10} height={20} inline={true} width="5vw"
                                      containerClassName={classes.skeletonBodyCellWrapper}/>
                            <Skeleton borderRadius={10} height={20} inline={true} width="4vw"
                                      containerClassName={classes.skeletonBodyCellWrapper}/>

                        </div>
                        <div>
                            {Array.apply(null, Array(DEFAULT_ROWS_PER_PAGE)).map((_, idx) => {
                                return (
                                    <div className={classes.skeletonBodyRow} key={idx}>
                                        <Skeleton
                                            borderRadius={10}
                                            height={20}
                                            inline={true}
                                            width={`${8 + (Math.random() * 2)}vw`}
                                            containerClassName={classes.skeletonBodyCellWrapper}
                                        />
                                        <Skeleton
                                            borderRadius={10}
                                            height={20}
                                            inline={true}
                                            width={`${3 + Math.random()}vw`}
                                            containerClassName={classes.skeletonBodyCellWrapper}
                                        />
                                        <Skeleton
                                            borderRadius={10}
                                            height={20}
                                            inline={true}
                                            width={`${3 + (Math.random() * 2)}vw`}
                                            containerClassName={classes.skeletonBodyCellWrapper}
                                        />
                                    </div>
                                )
                            })}
                        </div>
                    </SkeletonTheme>
                </div>

            </div>
        );
    }

    if(activeStep.isLast) {
        return (
            <div className={classes.column} style={{width: "100%"}}>
                <div className={classes.row} style={{flexWrap: "wrap", rowGap: 10, columnGap: 20 }}>
                    <div className={classes.description} style={{flex: 1, minWidth: 365}}>
                        {"View all questions from the \""}
                        <strong>
                            {questionBanks.find(qb => qb.id === selectedQuestionBank)?.title}
                        </strong>
                        {"\". Select the questions you would like to include in your poll."}
                    </div>
                    <div className={classes.badge} style={{minWidth: 140}}>
                        {importedQuestions.length}&nbsp;/&nbsp;{fakePoll.questions.length} Questions
                    </div>
                </div>

                <QuestionAccordion
                    fakePoll={fakePoll}
                    importedQuestions={importedQuestions}
                    setImportedQuestions={setImportedQuestions}
                />
            </div>
        );
    } else {
        return (
            <div className={classes.column} style={{width: "100%"}}>
                <div className={classes.description}>
                    {"Select the question bank name to import questions from."}
                </div>

                <YuJaTextBox
                    containerStyle={{
                        height: 40,
                        minWidth: 100,
                        maxWidth: 500,
                        fontSize: 14,
                        lineHeight: 1.6,
                        marginTop: 25,
                        marginBottom: 15,
                    }}
                    onChange={e => setKeyword(e.target.value)}
                    value={keyword}
                    before={<SearchIcon style={{marginRight: 5, width: 16}}/>}
                    after={
                        !!keyword
                            ? (
                                <YuJaButton
                                    style={{width: 24, height: 24}}
                                    aria-label={"Clear search keyword"}
                                    iconOnly={true}
                                    onClick={() => setKeyword("")}
                                >
                                    <CLOSE style={{width: 18, height: 18}}/>
                                </YuJaButton>
                            )
                            : (<></>)
                    }
                    placeholder={"Search by question bank name"}
                />
                <div className={classes.tableWrapper}>
                    <Table {...getTableProps()}>
                        <thead>
                        {headerGroups.map((headerGroup, index) => (
                            <tr key={index} {...headerGroup.getHeaderGroupProps()}>
                                {headerGroup.headers.map((column, idx) => (
                                    <TableSortHeaderNew
                                        key={idx}
                                        data={questionBanks}
                                        setData={setQuestionBanks}
                                        sortedBy={sortedBy}
                                        setSortedBy={setSortedBy}
                                        propertyName={column.id}
                                        label={column.Header}
                                        {...column.getHeaderProps({
                                            style: {
                                                width: column.width,
                                                minWidth: column.minWidth,
                                                maxWidth: column.maxWidth,
                                                textAlign: 'left',
                                                paddingLeft: idx === 0 ? 45 : undefined
                                            }
                                        })}
                                    >
                                        {column.Header}
                                    </TableSortHeaderNew>
                                ))}
                            </tr>
                        ))}
                        </thead>

                        <RadioGroup
                            value={selectedQuestionBank ?? ""}
                            onValueChange={(val, e) => {
                                setSelectedQuestionBank(val);
                            }}
                            {...getTableBodyProps()}
                            render={(props) => <tbody {...props}></tbody>}
                        >
                            {!page.length &&
                                <tr>
                                    <td colSpan={3}>
                                        <div className={classes.column} style={{flex: 1, padding: "20px 0", justifyContent: "center"}}>
                                            <div className={classes.column} style={{alignItems: "center"}}>
                                                <NoResultImage style={{height: 150, alignSelf: "center", margin: "20px 0"}}/>
                                                <span style={{alignSelf: "center", fontSize: 20, fontWeight: "700", lineHeight: 1.4}}>
                                                    No Matching Question Banks found
                                                </span>
                                                <span style={{alignSelf: "center", marginTop: 20}}>
                                                    Try adjusting your search or filters to find a Question Bank.
                                                </span>
                                            </div>
                                        </div>
                                    </td>
                                </tr>
                            }
                            {page.map((row, index) => {
                                prepareRow(row);
                                return (
                                    <tr key={index}{...row.getRowProps()}>
                                        {row.cells.map((cell, cellIdx) => {

                                            return (
                                                <td key={cellIdx}>
                                                    <div className={classes.row} style={{width: "100%"}}>
                                                        {cell.column.Header === QUESTION_BANK_TITLE_HEADER
                                                            ? (
                                                                <label
                                                                    title={!!cell.value ? cell.value : ""}
                                                                    className={radioClasses.Item}
                                                                    style={{gap: 8, padding: "5px 0 5px 12px"}}
                                                                >
                                                                    <Radio.Root value={row.original.id} className={radioClasses.Radio}>
                                                                        <Radio.Indicator className={radioClasses.Indicator} keepMounted={true}/>
                                                                    </Radio.Root>
                                                                    <span
                                                                        style={{
                                                                            flex: "0 1 auto",
                                                                            minWidth: 0,
                                                                            textOverflow: "ellipsis",
                                                                            whiteSpace: "nowrap",
                                                                            overflow: "hidden",
                                                                            display: "inline-block",
                                                                        }}
                                                                    >
                                                                        {!cell.value ? "-" : cell.value}
                                                                    </span>

                                                                </label>
                                                            )
                                                            : (
                                                                <span
                                                                    style={{
                                                                        flex: "0 1 auto",
                                                                        minWidth: 0,
                                                                        textOverflow: "ellipsis",
                                                                        whiteSpace: "nowrap",
                                                                        overflow: "hidden",
                                                                        display: "inline-block",
                                                                    }}
                                                                    title={!!cell.value ? cell.value : ""}
                                                                >
                                                                    {!cell.value ? "-" : cell.value}
                                                                </span>
                                                            )
                                                        }
                                                    </div>

                                                </td>
                                            );
                                        })}
                                    </tr>
                                );
                            })}
                        </RadioGroup>
                    </Table>
                </div>

                {pageCount > 1 &&
                    <NormalPagination
                        pageCount={pageCount}
                        pageIndex={pageIndex}
                        pageOptions={pageOptions}
                        canPreviousPage={canPreviousPage}
                        canNextPage={canNextPage}
                        previousPage={previousPage}
                        nextPage={nextPage}
                        gotoPage={gotoPage}
                    />
                }
            </div>
        );
    }

}